<template>
  <el-dialog title="添加比較" :visible.sync="dialogVisible" width="30%" :before-close="handleClose" class="dialogEdit">
    <el-form :model="form" label-width="80px">
      <el-form-item label="名稱" >
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
<!-- 
      <el-form-item label="是否顯示" >
        <el-switch v-model="form.status"></el-switch>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit">確 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "compare_dialog",
  data() {
    return {
      dialogVisible: false,
      formLabelWidth: 30,
      form: {
        name: "",
        status: true
      }
    };
  },
  methods: {
    show(value) {
      this.dialogVisible = true;
      if (value !== undefined) {
        this.form = Object.assign({}, value);
        this.form.status = this.form.status == 1 ? true : false;
      } else {
        this.form = { name: "", status: true };
      }
    },
    onSubmit() {
      var self = this;
      let params = Object.assign({}, this.form);
      this.$http.post("/admin/compare/edit", params).then(res => {
        self.$emit("sucess",res.data);
        this.dialogVisible = false;
      });
    }
  }
};
</script>
<style lang="less">
.dialogEdit{
    text-align:left;
    
}
</style>